import React from "react";
import "../Assets/Style/Inputs.scss";

export const Textbox = ({ value, onChange, disabled = false, name, label="", type="text", placeholder="" }) => {
  return (
    <div className="TextBox">
      <label htmlFor={name}>{label}</label>
      <input
        type={type}
        name={name}
        onChange={onChange}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
      />
    </div>
  );
};

export const TextArea = ({ value, onChange, disabled = false, name, label="", type="text",rows=10 }) => {
  return (
    <div className="TextBox">
      <label htmlFor={name}>{label}</label>
      <textarea
        type={type}
        name={name}
        onChange={onChange}
        rows={rows}
        value={value}
        disabled={disabled}
      ></textarea>
    </div>
  );
};
